module.exports = __webpack_public_path__ + "static/media/TruthSeekers_Background.10323800.png";